import api from "utils/axios";

export async function getAppSettings() {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/settings/get-x-app-settings`);

    if (!data || !data.success) {
      throw new Error(data.message || "Failed to fetch app settings");
    }

    return {
      success: true,
      data: data.data,
    };
  } catch (error) {
    console.error("Error getting app settings:", error);
    return {
      success: false,
      message: "Failed to load settings"
    }
  }
}

export async function updateAppSettings(settings) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/settings/update-x-app-settings`, settings);

    if (!data || !data.success) {
      throw new Error(data.message || "Failed to update app settings");
    }

    return {
      success: true,
      message: "Settings updated successfully",
      data: data.data,
    };
  } catch (error) {
    console.error("Error updating app settings:", error);
    return {
      success: false,
      message: "Failed to update settings",
    };
  }
}

export async function sendEmailOTP() {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/auth/send-email-otp`);

    if (!data || !data.success) {
      throw new Error(data.message || "Failed to send OTP");
    }

    return {
      success: true,
      message: data.message || "OTP sent successfully"
    };
  } catch (error) {
    console.error("Error sending OTP:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to send OTP",
    };
  }
}

export async function resetPassword(otp, newPassword) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/auth/reset-password`, {
      otp,
      newPassword
    });

    if (!data || !data.success) {
      throw new Error(data.message || "Failed to reset password");
    }

    return {
      success: true,
      message: data.message || "Password reset successfully"
    };
  } catch (error) {
    console.error("Error resetting password:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to reset password",
    };
  }
}